import { Entity, EntityAcl, FormNode } from '@msdk/definitions'
import { atom } from 'recoil'

export interface CollectionEntry {
  entity: Entity
  acl: EntityAcl
  additionalEntities: Entity[]
  rootNode: FormNode
  /**
   * whether or not the form has been modified
   */
  pendingChanges: boolean
}

export const $entityCollection = atom<Record<string, CollectionEntry>>({
  key: 'EntityCollection',
  default: {},
  dangerouslyAllowMutability: true,
})
